import http from './http';

export default {
  getRounds({
    wheelId,
    wheelAccountId,
    dateFrom,
    dateTo,
    page,
    pageSize,
    search,
    sortBy,
    sortOrder,
    timezoneOffset,
  }) {
    return http.get(`/rounds/${wheelId}`, {
      params: {
        wheelAccountId,
        dateFrom,
        dateTo,
        page,
        pageSize,
        search,
        sortBy,
        sortOrder,
        timezoneOffset,
      },
    }).then((response) => {
      const result = response.data;
      return result;
    });
  },
};
